import httpBuildQuery from 'http-build-query';
import API from './api';

export default {
    getInventory(id) {
        return API.get(`inventorylist/type/${id}`).then(res => (res.data));
    },
    getWarehouseInventory2(id, invtDate = '') {
        let deliveryDate = '';
        if (invtDate !== '') {
            deliveryDate = `/inventorydate/${invtDate}`;
        }
        return API.get(`getwarehouseinventory2/locationid/${id}${deliveryDate}`).then(res => (res.data));
    },
    getWarehouseInventory(id) {
        return API.get(`getwarehouseinventory/locationid/${id}`).then(res => (res.data));
    },
    getDistributionData(id) {
        return API.get(`warehousedistributiondata/batchid/${id}`).then(res => (res.data));
    },
    addWarehouseInventory(formdata) {
        return API.post('addwarehouseinventory', httpBuildQuery(formdata)).then(res => (res.data));
    },
    addWarehouseTransaction(formdata) {
        return API.post('addwarehousetransaction', httpBuildQuery(formdata)).then(res => (res.data));
    },
    fishinfishout(formdata) {
        return API.post('fishinfishout', httpBuildQuery(formdata)).then(res => (res.data));
    },
};
